/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agTypes from './ag-types.constant';
import agUtils from './ag-utils.service';
import agFilters from './filter/ag-filters';
import agValidators from './validator/ag-validators';
import agSites from './site/sites.directive';
import agSiteAssets from './site/site-assets.directive';
import agSiteMap from './site/site-map.directive';
import agSiloDrawing from './silo/silo-drawing.directive';
import agSilo3dDrawing from './silo/silo-3d-drawing.directive';
import agTemperatureInput from './components/temperature-input.directive';
import agValueInput from './components/value-input.directive';
import agEntityList from './components/entity-list.directive';

export default angular.module('agrolog.common', [
    agTypes,
    agUtils,
    agFilters,
    agValidators,
    agSites,
    agSiteAssets,
    agSiteMap,
    agSiloDrawing,
    agSilo3dDrawing,
    agTemperatureInput,
    agValueInput,
    agEntityList])
    .name;